import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'cream' | 'white' | 'green' | 'dark';
  delay?: number;
}
export function Section({
  children,
  className = '',
  id,
  background = 'cream',
  delay = 0
}: SectionProps) {
  const backgrounds = {
    cream: 'bg-[#FFF8F0]',
    white: 'bg-white',
    green: 'bg-[#E8F5E9]',
    dark: 'bg-[#1B4332] text-white'
  };
  return <section id={id} className={`py-12 md:py-20 px-4 sm:px-6 lg:px-8 overflow-hidden ${backgrounds[background]} ${className}`} data-id="element-78">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6,
      delay,
      ease: 'easeOut'
    }} className="max-w-4xl mx-auto" data-id="element-79">
        {children}
      </motion.div>
    </section>;
}